import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const ScrollToTop = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

 
useEffect(() => {
  
    const handleReloadScroll = () => {
      window.scrollTo(0, 0);
    };

    window.addEventListener('beforeunload', handleReloadScroll);
    return () => {
      window.removeEventListener('beforeunload', handleReloadScroll);
    };
  }, []);

  return null;
};

export default ScrollToTop;
